export const ADDRESS_KEYS = [
  'street_1',
  'street_2',
  'company',
  'town',
  'country',
  'postal_code',
]

export default undefined
